import React from 'react';
import { connect } from 'react-redux';

import { Conference, _connect } from './Conference';

import { Whiteboard } from '../../../whiteboard';
import { Chat } from '../../../chat';
import { Filmstrip } from '../../../filmstrip';
import { default as Notice } from './Notice';
import { LargeVideo } from '../../../large-video';
import { ParticipantsPane } from '../../../participants-pane/components/web';
import { KnockingParticipantList } from '../../../lobby';
import { Toolbox } from '../../../toolbox/components/web';
import { CalleeInfoContainer } from '../../../invite';
import { Prejoin } from '../../../prejoin';

import { closeChat } from '../../../chat';
import { close as closeParticipantPane } from '../../../participants-pane/actions';

class RPC_Conference extends Conference {
    constructor(props) {
        super(props);
        this._onVideoSpaceClick = this._onVideoSpaceClick.bind(this);
    }

    componentDidMount() {
        document.querySelector("link[rel='icon']").href = '/' + interfaceConfig.DEFAULT_FAVICON;
        super.componentDidMount();
    }

    componentDidUpdate(prevProps) {
        document.title = `${this.props._roomName} | ${interfaceConfig.APP_NAME}`;
        super.componentDidUpdate(prevProps);
    }

    _onVideoSpaceClick() {
        const { dispatch, _isChatOpen } = this.props;
        if(_isChatOpen)
            dispatch(closeChat());
        dispatch(closeParticipantPane());
    }

    render() {
        const {
            _isLobbyScreenVisible,
            _isParticipantsPaneVisible,
            _layoutClassName,
            _showPrejoin,
            _recordingSession
        } = this.props;

        return (
            <div id = 'layout_wrapper'>
                <div
                    className = { _layoutClassName }
                    id = 'videoconference_page'
                    onMouseMove = { this._onShowToolbar }
                    ref = { this._setBackground }>

                    <Notice />
                    <div id = 'videospace' onClick = { this._onVideoSpaceClick }>
                        <LargeVideo />
                        {!_isParticipantsPaneVisible && <KnockingParticipantList />}
                        <Filmstrip />
                        <Whiteboard />
                    </div>

                    { _showPrejoin || _isLobbyScreenVisible || <Toolbox /> }
                    <Chat />

                    { this.renderNotificationsContainer() }

                    <CalleeInfoContainer />

                    { _showPrejoin && <Prejoin />}

                    { _recordingSession && <div className="recording-bulb">
                        <span></span> Recording...
                    </div>}

                </div>
                <ParticipantsPane />
            </div>
        );
    }
}

function _mapStateToProps(state) {
    return {
        _recordingSession: state['features/recording'].sessionDatas.find(d => d.status == 'on'),
        _isChatOpen: state['features/chat'].isOpen
    };
}

export default _connect(connect(_mapStateToProps)(RPC_Conference));